import { createContext, useContext } from "react"

import { ViewBarContextValues } from "./ViewBar.types"

export const ViewBarContext = createContext<ViewBarContextValues | undefined>(undefined)
ViewBarContext.displayName = "ViewBar"

export default function useViewBar(): ViewBarContextValues {
    const context = useContext(ViewBarContext)
    if (!context) {
        throw new Error("useViewBar must be used within a ViewBar.Root component")
    }
    return context
}
